module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/txt-e41ae.png";